import { useEffect, useState } from "react";
import { ArrowUpRight, Menu, X } from "lucide-react";

export const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 32);
    window.addEventListener("scroll", handler);
    handler();
    return () => window.removeEventListener("scroll", handler);
  }, []);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const links = [
    { href: "#manifesto", label: "A Kora Club" },
    { href: "#vip", label: "Lista VIP" },
  ];

  const handleClick = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      <nav
        data-testid="primary-nav"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${
          scrolled || open
            ? "bg-kora-forest/90 backdrop-blur-md border-b border-kora-gold/20 pt-0"
            : "bg-transparent pt-[36px] nav-on-hero"
        }`}
      >
        <div className="max-w-[1480px] mx-auto px-6 md:px-12 py-5 flex items-center justify-between relative z-[60]">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              handleClick("#hero");
            }}
            data-testid="nav-logo"
            className="flex items-baseline gap-1 text-kora-cream"
          >
            <span className="font-display text-2xl tracking-tight">KORA</span>
            <span className="font-display italic text-2xl text-kora-gold-light">
              Club
            </span>
          </a>

          <div className="hidden md:flex items-center gap-10">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleClick(l.href);
                }}
                className="font-mono-label text-kora-cream/80 hover:text-kora-gold-light transition-colors duration-500 link-underline"
              >
                {l.label}
              </a>
            ))}
          </div>

          <button
            data-testid="nav-cta-desktop"
            onClick={() => handleClick("#vip")}
            className="hidden md:inline-flex btn-outline-gold"
          >
            Entrar no Clube
            <ArrowUpRight size={14} className="arrow" />
          </button>

          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="md:hidden text-kora-cream p-1 relative z-[70]"
            aria-label="menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      {/* Mobile full-screen overlay — rendered OUTSIDE <nav> so no
          backdrop-filter containing block interferes with position:fixed */}
      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden fixed inset-0 flex flex-col px-6 pt-28 pb-10 z-[55] animate-fade-in"
          style={{ backgroundColor: "rgba(10,20,15,0.97)" }}
        >
          {/* Close button inside overlay (above nav's toggle due to stacking context) */}
          <button
            data-testid="nav-mobile-close"
            onClick={() => setOpen(false)}
            aria-label="fechar menu"
            className="absolute top-5 right-6 text-kora-cream p-1"
          >
            <X size={24} />
          </button>

          <ul className="flex flex-col gap-7 flex-1">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleClick(l.href);
                  }}
                  className="font-display text-4xl text-kora-cream block"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
          <button
            data-testid="nav-cta-mobile"
            onClick={() => handleClick("#vip")}
            className="btn-outline-hero self-start"
          >
            Entrar no Clube
            <span className="arrow">→</span>
          </button>
          <p className="font-mono-label text-kora-cream/50 mt-8">
            ✦ Movimento que te define
          </p>
        </div>
      )}
    </>
  );
};
